import { Injectable } from '@angular/core';
import { Pageable, ResponseAPI } from '@models/response';
import { BaseService } from '@services/base.service';
import { AreaModel, HistoryModel, WalletModel } from './n19.model';

@Injectable({
  providedIn: 'root'
})
export class N19Service extends BaseService {
  constructor() {
    super();
  }

  getHistory(page: number, size: number, type: string) {
    return this.httpClient.get<ResponseAPI<Pageable<HistoryModel[]>>>(`/N19/history?page=${page}&size=${size}&regionType=${type}`);
  }

  getWallet(page: number, size: number, type: string) {
    // return this.httpClient.get<ResponseAPI<WalletModel[]>>(`/N19/wallet?page=${page}&size=${size}`);
    return this.httpClient.get<ResponseAPI<Pageable<WalletModel[]>>>(`/N19/wallet?page=${page}&size=${size}&regionType=${type}`);
  }

  getUpdate(body) {
    return this.httpClient.post<ResponseAPI<any>>(`/N19/update`, body);
  }
}
